var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEwa = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM0 4.5v6.3L1.2 12h2.55V8.25h16.5V12h2.55l1.2-1.2V4.5H0Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.25 15.75c-1.275 0-2.25.975-2.25 2.25H9c0-1.275-.975-2.25-2.25-2.25V9h-1.5v10.5h13.5V9h-1.5v6.75Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.001 9.75c0-.3-.075-.525-.15-.75H9.226c-.075.225-.15.45-.15.75 0 1.275 1.35 2.25 3 2.25s2.925-.975 2.925-2.25Z"
})));
export default SvgEwa;